import React, { createContext, useContext, useState, useEffect } from 'react';

const PartyFilterContext = createContext(null);

export const PartyFilterProvider = ({ children }) => {
  const [selectedPartyId, setSelectedPartyId] = useState(() => {
    // Load from localStorage on init
    return localStorage.getItem('selectedPartyId') || 'all';
  });

  // Persist to localStorage when changed
  useEffect(() => {
    if (selectedPartyId === 'all') {
      localStorage.removeItem('selectedPartyId');
    } else {
      localStorage.setItem('selectedPartyId', selectedPartyId);
    }
  }, [selectedPartyId]);

  const resetFilter = () => {
    setSelectedPartyId('all');
  };

  return (
    <PartyFilterContext.Provider value={{
      selectedPartyId,
      setSelectedPartyId,
      resetFilter,
      isFiltered: selectedPartyId !== 'all'
    }}>
      {children}
    </PartyFilterContext.Provider>
  );
};

export const usePartyFilter = () => {
  const context = useContext(PartyFilterContext);
  if (!context) {
    throw new Error('usePartyFilter must be used within a PartyFilterProvider');
  }
  return context;
};
